import { useState } from "react";
import { Crown, Check } from "lucide-react";
import { IntervalSwitch } from "@/components/PricingSection";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PLANS, INTERVALS, TRIAL_DAYS } from "@/lib/plans";

export const UpgradeDialog = ({ reason, onClose, onUpgrade, trialEligible }) => {
  const [interval, setInterval] = useState("month");
  const iv = INTERVALS[interval];
  return (
  <Dialog open={!!reason} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="upgrade-dialog" className="bg-[#141018] border-[#5a1e28] rounded-none max-w-md">
      <DialogHeader>
        <DialogTitle className="font-gothic uppercase tracking-wider text-amber-100/90 flex items-center gap-2">
          <Crown size={18} className="text-[#D99B43]" /> Ascend to Pro
        </DialogTitle>
        <DialogDescription className="font-cormorant italic text-lg text-stone-300" data-testid="upgrade-dialog-reason">
          {reason}
        </DialogDescription>
      </DialogHeader>
      <ul className="space-y-2 my-2">
        {PLANS[1].features.slice(0, 4).map((f) => (
          <li key={f} className="flex items-center gap-2 text-sm text-stone-300">
            <Check size={14} className="text-[#D99B43]" /> {f}
          </li>
        ))}
      </ul>
      <IntervalSwitch value={interval} onChange={setInterval} testId="upgrade-interval" />
      <button
        data-testid="upgrade-dialog-subscribe-btn"
        onClick={() => {
          onClose();
          onUpgrade(interval);
        }}
        className="btn-crimson w-full justify-center"
      >
        <Crown size={14} /> {trialEligible ? `Start ${TRIAL_DAYS}-day free trial` : `Subscribe · ${iv.price}/${iv.per}`}
      </button>
      <p className="text-[11px] text-stone-500 text-center" data-testid="upgrade-dialog-fine">
        {trialEligible ? `Free for ${TRIAL_DAYS} days, then ${iv.price}/${iv.per} plus applicable tax.` : `Billed ${iv.price}/${iv.per} plus applicable tax.`} Cancel anytime from your account menu.
      </p>
    </DialogContent>
  </Dialog>
  );
};
